<div
  #chartHost
  class="finance-profitability-chart-host w-full"
  [attr.aria-label]="ariaLabel"
></div>
